module.exports = require("./pt-LU.d.ts");